import React, { Fragment, useEffect, useState } from 'react';

import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { API_Ingetration } from '../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import ActiveConversations from './Components/activeConversation';
import AllConversations from './Components/allConversation';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ConnectOptions from './Components/connectOptions';
import Tickets from './Components/tickets';

// import JsSIP from 'jssip';
import JsSIP from 'jssip';
import DialPad from './Components/dialPad';
var jsSip1 = require('jssip');
var socket = new JsSIP.WebSocketInterface('wss:/sip.myhost.com');
var configuration = {
  sockets: [socket],
  uri: 'sip:alice@example.com',
  password: 'superpassword',
};

const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }
  
  .btn-round {
    border-radius:5px!important;
  }

  .rtc:hover{
    background:none!important;
    color: black!important;
  }
  .nav-width{
    width: 'auto';
    background: '';
  }
  `;

function AgentAssist({ propertyId, location }) {
  var ticketCategory =
    location !== undefined &&
    location.state !== undefined &&
    location.state.categoryvalue != undefined
      ? location.state.categoryvalue
      : undefined;
  const [activeTab, setActiveTab] = useState('Active');
  const [selectedChat, setSelectedChat] = useState();
  const [integrations, setIntegrations] = useState();
  const [dialPadVisible, setDialPadVisible] = useState(false);
  const handleSelectedTab = (val) => {
    console.log(val);
    setSelectedChat(val);
  };

  const handleActiveTab = (val) => {
    setActiveTab(val);
  };
  const LoadIntegrations = () => {
    let body = {
      channels: [
        'FacebookDirectLine',
        'Phone',
        'WeChat',
        'SHRCRS',
        'Amadues',
        'EmailDirectLine',
        'Amazon',
        'WhatsApp',
        'WebRTC',
      ],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        setIntegrations(res.data.length > 0 ? res.data : []);
        setTimeout(() => {
          if (
            document.getElementById('app-container') !== undefined &&
            document.getElementById('app-container') !== null
          ) {
            document
              .getElementById('app-container')
              .classList.add('main-hidden');
            document
              .getElementById('app-container')
              .classList.add('sub-hidden');
          }

          const isInFullScreen = fullScreen();
          var docElm = document.documentElement;
          if (isInFullScreen !== undefined) {
            if (!isInFullScreen) {
              if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
              } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
              } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
              } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen();
              }
            } else {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
              }
            }
          }
        }, 2000);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (ticketCategory !== undefined) {
      setActiveTab('Tickets');
    } else {
      if (window.history.state?.state && window.history.state?.state?.from) {
        setActiveTab('Active');
      } else {
        setActiveTab('AllConversations');
      }
    }
    LoadIntegrations();

    //if()
  }, [propertyId]);

  const fullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  return (
    <Fragment>
      <style>{style_css}</style>
      <div
        style={{ marginLeft: '-3%', marginRight: '-3%', marginTop: '-0.75%' }}
      >
        {activeTab === 'Active' && integrations !== undefined && (
          <ActiveConversations
            activeTab={activeTab}
            integrations={integrations}
            handleSelectedTab={handleActiveTab}
          ></ActiveConversations>
        )}

        {activeTab === 'AllConversations' && integrations !== undefined && (
          <AllConversations
            activeTab={activeTab}
            integrations={integrations}
            handleSelectedTab={handleActiveTab}
            location={location}
          ></AllConversations>
        )}

        {activeTab === 'Tickets' && integrations !== undefined && (
          <Tickets
            activeTab={activeTab}
            integrations={integrations}
            handleSelectedTab={handleActiveTab}
            categoryValue={ticketCategory}
          ></Tickets>
        )}
        {/* {integrations !== undefined && integrations !== undefined &&
                    <ConnectOptions integrations={integrations}></ConnectOptions>} */}
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ chatListApp, usersListApp, settings }) => {
  const { propertyId, timeZone, locale, email } = settings;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(AgentAssist));
